import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import {
  TextControl,
  ToggleControl,
  SelectControl,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from '@wordpress/components';

import PanelBody from '../../../../components/PanelBody';
import Slider from '../../../../components/Slider';

const LEVEL_OPTIONS = [1, 2, 3, 4, 5, 6].map((level) => ({
  value: level,
  label: `H${level}`,
}));

export default function AllInspectorControls({ attributes, setAttributes }) {
  const {
    title,
    minLevel,
    maxLevel,
    listStyle,
    collapsible,
    startCollapsed,
    scrollSpy,
    smoothScroll,
    scrollOffset,
    nested,
  } = attributes;

  return (
    <InspectorControls>
      <PanelBody title={__('Contents', 'brandy-blocks')} initialOpen>
        <TextControl
          label={__('Title', 'brandy-blocks')}
          value={title}
          onChange={(value) => setAttributes({ title: value })}
          help={__('Leave empty to hide the header.', 'brandy-blocks')}
          __nextHasNoMarginBottom
        />

        <SelectControl
          label={__('From level', 'brandy-blocks')}
          value={minLevel}
          options={LEVEL_OPTIONS}
          onChange={(value) => {
            const next = Number(value);
            // Keep the range valid without silently discarding the click the
            // author just made — push the other end instead.
            setAttributes({
              minLevel: next,
              ...(next > maxLevel ? { maxLevel: next } : {}),
            });
          }}
          __nextHasNoMarginBottom
        />

        <SelectControl
          label={__('To level', 'brandy-blocks')}
          value={maxLevel}
          options={LEVEL_OPTIONS}
          onChange={(value) => {
            const next = Number(value);
            setAttributes({
              maxLevel: next,
              ...(next < minLevel ? { minLevel: next } : {}),
            });
          }}
          __nextHasNoMarginBottom
        />

        <ToggleGroupControl
          label={__('List style', 'brandy-blocks')}
          value={listStyle}
          onChange={(value) => setAttributes({ listStyle: value })}
          isBlock
          __nextHasNoMarginBottom
        >
          <ToggleGroupControlOption value="numbered" label={__('Numbers', 'brandy-blocks')} />
          <ToggleGroupControlOption value="bulleted" label={__('Bullets', 'brandy-blocks')} />
          <ToggleGroupControlOption value="plain" label={__('Plain', 'brandy-blocks')} />
        </ToggleGroupControl>

        <ToggleControl
          label={__('Indent sub-headings', 'brandy-blocks')}
          checked={nested}
          onChange={(value) => setAttributes({ nested: value })}
          __nextHasNoMarginBottom
        />
      </PanelBody>

      <PanelBody title={__('Behavior', 'brandy-blocks')} initialOpen={false}>
        <ToggleControl
          label={__('Collapsible', 'brandy-blocks')}
          checked={collapsible}
          onChange={(value) => setAttributes({ collapsible: value })}
          help={__('Turns the header into a show/hide toggle.', 'brandy-blocks')}
          __nextHasNoMarginBottom
        />

        {collapsible && (
          <ToggleControl
            label={__('Start collapsed', 'brandy-blocks')}
            checked={startCollapsed}
            onChange={(value) => setAttributes({ startCollapsed: value })}
            __nextHasNoMarginBottom
          />
        )}

        <ToggleControl
          label={__('Highlight the section in view', 'brandy-blocks')}
          checked={scrollSpy}
          onChange={(value) => setAttributes({ scrollSpy: value })}
          __nextHasNoMarginBottom
        />

        <ToggleControl
          label={__('Smooth scrolling', 'brandy-blocks')}
          checked={smoothScroll}
          onChange={(value) => setAttributes({ smoothScroll: value })}
          help={__(
            'Ignored for visitors who ask for reduced motion.',
            'brandy-blocks'
          )}
          __nextHasNoMarginBottom
        />

        <Slider
          label={__('Scroll offset (px)', 'brandy-blocks')}
          value={scrollOffset}
          onChange={(value) => setAttributes({ scrollOffset: value })}
          min={0}
          max={300}
        />
      </PanelBody>
    </InspectorControls>
  );
}
